<template>
  <div>
    <v-list v-if="activeNotifications.length > 0">
      <v-list-item
        v-for="notification in activeNotifications"
        :key="'notification-' + notification.id"
        class="pr-0"
      >
        <v-list-item-content>
          <v-list-item-title :title="getReadableNotificationType(notification)">{{ getReadableNotificationType(notification) }}</v-list-item-title>
          <v-list-item-subtitle
            :title="formatDate(notification.lastNotifiedAt, 'LLL')"
            class="mt-1"
          >
            <div style="" class="notification-item-subtitle">
              <span>{{ notification.message }}</span>
              <span v-if="notification.booking && notification.booking.id">
                &ndash; {{ transSingular('booking.booking') }}<booking-id :value="notification.booking.id" :open-in-new-tab="false" />
              </span>
              <span v-else-if="notification.object && notification.object.id">
                &ndash; <object-name :value="notification.object" :open-in-new-tab="false" />
              </span>
            </div>
            <div class="mt-1" style="font-size: 0.9em;">{{ formatFromNow(notification.lastNotifiedAt) }}</div>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <div class="d-flex justify-center">
            <v-chip>{{ notification.notifiedCount }}</v-chip>
            <notification-context-menu :notification="notification" />
          </div>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <div v-else class="d-flex justify-center align-center mb-5">
      <v-icon color="grey lighten-2" size="100">mdi-bell-check</v-icon>
    </div>
    <div class="d-flex justify-center mt-1">
      <v-btn small depressed block @click="pushToRoute('Notifications')"><v-icon left small>mdi-magnify</v-icon>{{ trans('notifications.showAll') }}</v-btn>
    </div>
  </div>
</template>

<script>
import {RouterUtils} from '@/utils/router-utils';
import {LocaleUtils} from '@/utils/locale-utils';
import {DateUtils} from '@/utils/date-utils';
import {NotificationUtils} from '@/utils/notification-utils';
import NotificationContextMenu from '@/components/notifications/NotificationContextMenu';
import BookingId from '@/components/BookingId';
import ObjectName from '@/components/ObjectName';

export default {
  name: 'NotificationsList',
  components: {
    ObjectName,
    BookingId,
    NotificationContextMenu
  },
  mixins: [
    LocaleUtils,
    RouterUtils,
    DateUtils,
    NotificationUtils
  ],
  props: {
    /** @type {NotificationDto[]} */
    activeNotifications: {
      required: true
    }
  }
}
</script>

<style scoped>
.notification-item-subtitle {
  white-space: pre-wrap; line-height: 15px; font-size: 0;
}
.notification-item-subtitle > * {
  font-size: 0.88rem;
}
</style>
